/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const recordDeviceMatchV1BodySchema = z.object({
  deviceId: z.string(),
  fingerprint: z.string(),
});

export type IRecordDeviceMatchV1Body = z.infer<typeof recordDeviceMatchV1BodySchema>;
